import { setCurrentFinanceYear } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "@/components/Toast";
import { BALANCE } from "../consts";
import { useNavigate } from "react-router-dom";

const useBalanceReports = () => {
  const {communityData, accessPermission, currentFinanceYear} = useSelector((state: RootState) => state.currentData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openTabs, setOpenTabs] = useState<string[]>([BALANCE]);
  
  const [cards, setCards] = useState<any[]>([]);
  
  useEffect(() => {
    if (accessPermission) {
      const crd = cards?.map((card: any) => ({
        ...card, 
        access: !!accessPermission?.[card.module]?.[card.accessKeys],
      }))
      setCards(crd);
    }
  }, [accessPermission]);
  
  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.bom}/${routes.finance}`,
        name: `Activity Dashboard`,
      },
      {
        link: "",
        name: <span className="text-primary">{"Balance Report"}</span>,
      },
    ],
    []
  );

  const onBackClick = () => {
    navigate(`/${routes.bom}/${routes.finance}`);
  };

  const onAccordionChange = (e: any) => {
    setOpenTabs(e);
  };

  const onExpandCollapse = () => {
    if (openTabs?.length) {
      setOpenTabs([]);
    } else {
      setOpenTabs([BALANCE]);
    }
  };

  const onCreateCardClick = (link: string) => () => {
    if (communityData) {
      navigate(link);
    } else {
      toast.error("Please select community");
    }
  };

  const onCardClick = (link: string) => () => {
    navigate(link);
  };
  
  const onYearChange = (e: any) => {
    dispatch(setCurrentFinanceYear(e));
  };
  
  return {
    cards,
    breadcrumbData,
    onBackClick,
    onAccordionChange,
    onExpandCollapse,
    onCreateCardClick,
    onCardClick,
    onYearChange,
    openTabs,
    communityData,
    currentFinanceYear
  };
};

export default useBalanceReports;
